export default __webpack_public_path__ + "static/media/rolling-on-the-floor-laughing.21f4e65a.png";